import { FC, useEffect } from "react";
import React from "react";
import AppDialog from "../AppDialog/AppDialog";
import Translate from "../Translate/Translate";
import { tracker } from "src/state/state";

const SkipLabsConfirmation: FC<{
  onConfirm: () => void;
  onClose: () => void;
  trackingName?: string;
}> = (props) => {
  const track = (action: string) => {
    if (props.trackingName) {
      tracker.track(`${props.trackingName} ${action}`);
    }
  };

  useEffect(() => {
    track("- open");
  }, [props.trackingName]);

  return (
    <AppDialog
      confirmText={"button.yesSkip"}
      cancelText={"button.noKeep"}
      onCancel={({ via }) => {
        props.onClose();
        track(`- ${via}`);
      }}
      onConfirm={() => {
        props.onConfirm();
        track("- confirm");
      }}
    >
      <h5>
        <Translate msg="skipInitialLabs.title" />
      </h5>
      <p>
        <Translate msg="skipInitialLabs.description" />
      </p>
    </AppDialog>
  );
};

export default SkipLabsConfirmation;
